import {createTheme} from '@mui/material/styles';

const openSansFont = {
  fontFamily: `"Open Sans", sans-serif`,
  textDecoration: 'none',
  textTransform: 'none',
  letterSpacing: '0.05em',
  fontWeight: 300,
};

export const openSans12Style = {
  ...openSansFont,
  fontSize: 12,
};
export const openSans14Style = {
  ...openSansFont,
  fontSize: 14,
};
export const openSans15Style = {
  ...openSansFont,
  fontSize: 15,
};
export const openSans16Style = {
  ...openSansFont,
  fontSize: 16,
};

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 728, // tablets
      md: 976, // small laptop
      lg: 1008, // desktop
      xl: 1350 // large screens
    }
  },
  typography: {
    h2: {
      fontFamily: '"Roboto Slab", sans-serif',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: '22px',
      letterSpacing: '0.05em',
      textAlign: 'unset',
      textTransform: 'unset'
    },
    openSans12: openSans12Style,
    openSans14: openSans14Style,
    openSans15: openSans15Style,
    openSans16: openSans16Style,
    instrumentAnchor: openSans14Style,
    instrumentSummaryInfo: {
      fontFamily: `"Open Sans", sans-serif`,
      fontSize: '12px',
      fontWeight: '400',
      letterSpacing: '0.05em',
    },
    instrumentTitle: {
      fontFamily: `"Roboto Slab", sans-serif`,
      fontSize: '20px',
      fontWeight: '700',
      letterSpacing: '0.05em',
    },
    instrumentSectionTitle: {
      fontFamily: `"Open Sans", sans-serif`,
      fontSize: '18px',
      fontWeight: '800',
      marginTop: 30,
      marginBottom: 20,
      letterSpacing: '0.05em',
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: openSans14Style
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          backgroundImage: "linear-gradient(#fff, #f7f7f7)"
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: '#444',
          marginTop: '3px',
          ...openSans12Style
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          ...openSans12Style,
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          ...openSans12Style,
          fontWeight: 'bold',
        },
        body: {
          ...openSans12Style,
          padding: '8px'
        }
      }
    }
  },
  palette: {
    background: {
      default: "#ffffff"
    },
    secondary: {
      main: '#004B78'
    },
    primary: {
      light: '#04629A',
      main: '#04629A'
    },
    info: {
      main: '#DCDEDF'
    }
  }
});

export default theme;
